
import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import './CompanyNews.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import renderHTML from 'react-render-html';
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function NewsEquity() {
    const [showResults, setShowResults] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [nameCom, setNameCom] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [co_code, setco_code] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const { getCompName } = useParams();
    const [companyInfo, setCompanyInfo] = useState([]);
    const [data, setData] = useState([]);
    // const [valuebtn, setValueBtn] = useState("desc");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    // const [corptype, settype] = useState('Dividend');
    const [currentPage, setCurrentPage] = useState(1);
    // const [cocode, setcocode] = useLocalStorage("cocode", "");
    // const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, companyInformation;
    let PageSize = 8;

    useEffect(() => {
        // if (groupValue === "BSE") {
        setloadingshow(true)
        if (co_code != '') {
            const getUrl = BaseURL + "NewsEquity";
            fetch(`${getUrl}/${co_code}/100`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);
                    companyInformation = data.data;
                setCompanyInfo(companyInformation);
                })
                .catch((error) => {
                });
        }


        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [co_code]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);

    const newsModal = (e) => {
        // alert("Hii")
        const fetchId = e.currentTarget.getAttribute('data-id');
        let filteredCompanyInformation = companyInfo.filter(oneData => { return parseInt(oneData['SNo']) === parseInt(fetchId) })
        // console.log(filteredCompanyInformation)

        setFilteredNewsData(filteredCompanyInformation)
        handleShow();
    }
    const handleClosePopup = () => {
        setShow(false);
    }
    // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }

    // const handleClick = () => {
    //     if (groupValue === "BSE") {
    //         const getUrl = BaseURL + "PeerComparison";
    //         fetch(`${getUrl}/${groupValue}/${compCode}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);

    //                 // console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     } else {
    //         const getUrl = BaseURL + "PeerComparison";
    //         fetch(`${getUrl}/${groupValue}/${compCode}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);
    //                 //console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     }

    // }
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Company News</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Company News</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Company News" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            <div className="table-class">
                                <div className='comp-table table-responsive'>
                                    <table className='table'>
                                        {/* <thead>
                                    <tr>
                                            
                                                
                                         </tr>
                                    </thead> */}
                                        <thead>

                                            {currentTableData && currentTableData.map(
                                                ({ Date, Time, Heading, SNo }) => (
                                                    <>
                                                        <tr>
                                                            <h6> <a data-id={SNo} onClick={newsModal}>

                                                                <a data-id={SNo} >
                                                                    <td className="newhead">{Heading} </td>
                                                                </a>
                                                            </a></h6></tr>
                                                        <tr><p> {(Date.split('T')[0])}  ({Time})</p></tr><br></br>
                                                        <hr className="hrBorder"></hr>


                                                    </>
                                                ))}
                                            {filteredNewsData &&
                                                filteredNewsData.map(({ SNo, Heading, Date, Time, ArtText }) => (
                                                    <Modal show={show} className="modal company-snap-modal">

                                                        <Modal.Body id="modal_info">
                                                            <div className="titleCompany">{Heading}</div>
                                                            <div className="btnDiv">
                                                                <div className="btncl" onClick={handleClosePopup} > X </div>
                                                            </div>
                                                            <div className="infoCompany">{renderHTML(ArtText)}</div>
                                                        </Modal.Body>

                                                    </Modal>
                                                ))}
                                        </thead>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }
                                </div>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer compNews"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default NewsEquity;
